import { render, staticRenderFns } from "./BrandIdBlock.vue?vue&type=template&id=78bd9d84&scoped=true"
import script from "./BrandIdBlock.vue?vue&type=script&lang=js"
export * from "./BrandIdBlock.vue?vue&type=script&lang=js"
import style0 from "./BrandIdBlock.vue?vue&type=style&index=0&id=78bd9d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd9d84",
  null
  
)

export default component.exports